<template>
  <v-dialog
    :value="open"
    @click:outside="closeDialog()"
    scrollable
    max-width="750"
  >
    <v-card tag="form" @submit.prevent="handleSubmit(submitForm)">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        rounded
        height="6"
      ></v-progress-linear>

      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            {{ DialogTitle }}

            <v-spacer></v-spacer>

            <v-btn icon @click="openInNewTab">
            <v-icon>
              mdi-open-in-new
            </v-icon>
            </v-btn>
          </v-card-title>
        </v-img>
      </v-card-title>
      <v-card-text class="bg-chat">
        <!-- SKELETON LOADER -->
        <v-row v-if="loading" class="my-3 flex-column">
          <v-col
            v-for="(item, idx) in [1, 2, 3]"
            :key="item"
            cols="7"
            :class="`${idx % 2 ? 'align-self-end' : 'align-self-start'}`"
          >
            <v-skeleton-loader
              type="list-item-two-line"
              max-width="550"
            ></v-skeleton-loader>
          </v-col>
        </v-row>

        <v-layout
          row
          align-start
          align-content-start
          class="px-6"
          v-if="!loading"
          ref="chatPreviewCDRRef"
        >
          <vuescroll
            v-if="messageList.length"
            :ops="{
              bar: {
                background: '#bacfcec0'
              },
              scrollPanel: {
                initialScrollY: '100%',
                scrollingY: true,
                speed: 300
              }
            }"
          >
            <!-- <v-row class="my-3 flex-column" style="width: 100%"> -->
            <!-- <v-col
              v-for="message in messageList"
              :key="message.id"
              cols="7"
              :class="`${message.fromMe ? 'align-self-end' : 'align-self-start'}`"
            >
              <v-card
                :elevation="3"
                max-width="550"
                class="shadow-3"
                :color="message.fromMe ? 'secondary' : ''"
                :dark="message.fromMe ? true : false"
                rounded
                shaped
              >
                <v-card-text :class="message.fromMe">
                  {{ message.body }}
                </v-card-text>
              </v-card>
            </v-col> -->
            <template v-for="messages in messageList">
              <template v-for="item in messages">
                <!-- FECHA -->
                <v-container :key="item.id + '-date'">
                  <v-row justify="center">
                    <v-col cols="12" md="auto">
                      <v-chip label x-small class="ma-2">
                        {{ dateFormat(item.created_at) }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-container>

                <!-- TEXTO -->
                <template v-if="item.mediaType === 'chat'">
                  <v-flex
                    xs8
                    offset-xs4
                    class="mb-2"
                    :key="item.id"
                    v-if="item.fromMe === 1"
                  >
                    <v-card dark class="shadow-2" color="secondary">
                      <v-card-text class="pb-1">
                        <pre
                          style="text-wrap: wrap !important;"
                          class="white--text text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </pre>

                        <span class="ml-n2">
                          <v-icon
                            v-if="item.ack >= 1"
                            small
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            >mdi-check</v-icon
                          >
                          <v-icon
                            v-if="item.ack >= 2"
                            small
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            class="ml-n3"
                            >mdi-check</v-icon
                          >
                        </span>
                        <small>
                          {{ item.created_at | getHour12Format }}
                        </small>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs8
                    class="mb-2"
                    :key="item.id"
                    v-else-if="item.fromMe === 0"
                  >
                    <v-card class="shadow-2">
                      <v-card-text class="pb-1">
                        <pre
                          style="text-wrap: wrap !important;"
                          class="text--primary text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </pre>

                        <span class="ml-n2">
                          <v-icon
                            v-if="item.ack >= 1"
                            small
                            :color="item.ack === 3 ? 'teal darken-1' : ''"
                          >
                            mdi-check
                          </v-icon>
                          <v-icon
                            v-if="item.ack >= 2"
                            small
                            class="ml-n3"
                            :color="item.ack === 3 ? 'teal darken-1' : ''"
                          >
                            mdi-check
                          </v-icon>
                        </span>
                        <small>
                          {{ item.created_at | getHour12Format }}
                        </small>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>

                <!-- VCARD -->
                <template v-if="item.mediaType === 'vcard'">
                  <v-flex
                    xs8
                    sm6
                    md4
                    offset-xs4
                    offset-sm6
                    offset-md8
                    class="mb-1"
                    :key="item.id"
                    v-if="item.fromMe === 1"
                  >
                    <v-card dark class="shadow-2" color="secondary">
                      <v-card-text class="pb-1">
                        <p class="white--text text--body-2 mb-1">
                          {{ item.body }}
                        </p>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs8
                    sm6
                    md5
                    class="mb-1"
                    :key="item.id"
                    v-else-if="item.fromMe === 0"
                  >
                    <v-card class="shadow-2">
                      <v-card-text class="pb-1">
                        <v-list-item small>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.body | getNameVCard }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.body | getNumberVCard }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>

                <!-- IMAGE -->
                <template
                  v-if="
                    item.mediaType === 'image' &&
                      !item.mediaUrl.endsWith('.pdf')
                  "
                >
                  <v-flex
                    xs8
                    offset-xs4
                    class="mb-1"
                    :key="item.id"
                    v-if="item.fromMe === 1"
                  >
                    <v-card
                      dark
                      class="shadow-2"
                      color="secondary"
                      max-width="500px"
                    >
                      <v-card-text class="pb-1">
                        <v-img
                          :src="item.mediaUrl"
                          :lazy-src="item.mediaUrl"
                          class="grey lighten-2"
                          @click="photoPreview(item.mediaUrl)"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <p
                          v-if="item.body"
                          class="white--text text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </p>

                        <span class="ml-n2">
                          <v-icon
                            v-if="item.ack >= 1"
                            small
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            >mdi-check</v-icon
                          >
                          <v-icon
                            v-if="item.ack >= 2"
                            small
                            class="ml-n3"
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            >mdi-check</v-icon
                          >
                        </span>
                        <small>
                          {{ item.created_at | getHour12Format }}
                        </small>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs8
                    class="mb-1"
                    :key="item.id"
                    v-else-if="item.fromMe === 0"
                  >
                    <v-card class="shadow-2" max-width="500px">
                      <v-card-text class="pb-1">
                        <v-img
                          :src="item.mediaUrl"
                          :lazy-src="item.mediaUrl"
                          class="grey lighten-2"
                          @click="photoPreview(item.mediaUrl)"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <p
                          v-if="item.body"
                          class="text--primary text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </p>

                        <span class="ml-n2">
                          <v-icon
                            v-if="item.ack >= 1"
                            small
                            :color="item.ack === 3 ? 'teal darken-1' : ''"
                            >mdi-check</v-icon
                          >
                          <v-icon
                            v-if="item.ack >= 2"
                            small
                            class="ml-n3"
                            :color="item.ack === 3 ? 'teal darken-1' : ''"
                            >mdi-check</v-icon
                          >
                        </span>
                        <small>
                          {{ item.created_at | getHour12Format }}
                        </small>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>

                <!-- ARCHIVO -->
                <template v-if="['document'].includes(item.mediaType)">
                  <v-flex
                    xs8
                    :offset-xs4="item.fromMe === 1"
                    class="mb-1"
                    :key="item.id"
                  >
                    <v-card
                      :dark="item.fromMe === 1"
                      class="shadow-2"
                      :color="item.fromMe === 1 ? 'secondary' : ''"
                    >
                      <v-card-text class="pb-1">
                        <v-card outlined style="border-radius: 9px !important">
                          <v-card-body>
                            <v-container>
                              <v-row align="center">
                                <v-col>
                                  <v-list-item dense class="px-0">
                                    <v-list-item-icon class="ml-0 mr-2">
                                      <v-icon
                                        large
                                        v-if="item.mediaUrl.endsWith('.pdf')"
                                      >
                                        mdi-file-pdf-box
                                      </v-icon>
                                      <v-icon
                                        large
                                        v-else-if="
                                          item.mediaUrl.endsWith('.xls') ||
                                            item.mediaUrl.endsWith('.xlsx') ||
                                            item.mediaUrl.endsWith('.csv')
                                        "
                                      >
                                        mdi-file-excel-box
                                      </v-icon>
                                      <v-icon
                                        large
                                        v-else-if="
                                          item.mediaUrl.endsWith('.doc') ||
                                            item.mediaUrl.endsWith('.docx') ||
                                            item.mediaUrl.endsWith('.odt')
                                        "
                                      >
                                        mdi-file-word-box
                                      </v-icon>
                                      <v-icon v-else>mdi-file</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ item.observaciones }}
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        {{ item.mediaUrl | typeDoc }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-body>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-btn
                              block
                              depressed
                              :href="item.mediaUrl"
                              target="_blank"
                            >
                              {{
                                item.mediaUrl.endsWith(".pdf")
                                  ? "Abrir"
                                  : "Descargar"
                              }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <p class="text--body-2 mt-3 mb-1">
                          {{ item.body }}
                        </p>

                        <span class="ml-n2">
                          <v-icon
                            v-if="item.ack >= 1"
                            small
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            >mdi-check</v-icon
                          >
                          <v-icon
                            v-if="item.ack >= 2"
                            small
                            class="ml-n3"
                            :color="item.ack === 3 ? 'teal lighten-2' : ''"
                            >mdi-check</v-icon
                          >
                        </span>
                        <small>
                          {{ item.created_at | getHour12Format }}
                        </small>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>

                <!-- VIDEO -->
                <template v-if="item.mediaType === 'video'">
                  <v-flex
                    xs8
                    offset-xs4
                    class="mb-1"
                    :key="item.id"
                    v-if="item.fromMe === 1"
                  >
                    <v-card dark class="shadow-2" color="secondary">
                      <v-card-text class="pb-1">
                        <video
                          controls
                          width="220px"
                          :src="item.mediaUrl"
                          :poster="item.mediaUrl"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        ></video>

                        <p
                          v-if="item.body"
                          class="text--primary text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </p>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs8
                    class="mb-1"
                    :key="item.id"
                    v-else-if="item.fromMe === 0"
                  >
                    <v-card class="shadow-2">
                      <v-card-text class="pb-1">
                        <video
                          controls
                          width="220px"
                          :src="item.mediaUrl"
                          :poster="item.mediaUrl"
                          aspect-ratio="1"
                          class="grey lighten-2"
                        ></video>

                        <p
                          v-if="item.body"
                          class="text--primary text--body-2 mb-1"
                        >
                          {{ item.body }}
                        </p>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>

                <!-- VOICE -->
                <template
                  v-if="item.mediaType === 'ptt' || item.mediaType === 'audio'"
                >
                  <v-flex
                    xs8
                    sm7
                    offset-xs4
                    offset-sm5
                    class="mb-1"
                    :key="item.id"
                    v-if="item.fromMe === 1"
                  >
                    <v-card dark class="shadow-2" color="secondary">
                      <v-card-text class="pb-1">
                        <audio style="width:100%" controls>
                          <source :src="item.mediaUrl" type="audio/ogg" />
                        </audio>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex
                    xs8
                    sm7
                    class="mb-1"
                    :key="item.id"
                    v-else-if="item.fromMe === 0"
                  >
                    <v-card class="shadow-2">
                      <v-card-text class="pb-1">
                        <audio style="width:100%" controls>
                          <source :src="item.mediaUrl" type="audio/ogg" />
                        </audio>

                        <div>
                          <span class="ml-n2">
                            <v-icon
                              v-if="item.ack >= 1"
                              small
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              v-if="item.ack >= 2"
                              small
                              class="ml-n3"
                              :color="item.ack === 3 ? 'teal darken-1' : ''"
                              >mdi-check</v-icon
                            >
                          </span>
                          <small>
                            {{ item.created_at | getHour12Format }}
                          </small>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </template>
              </template>
            </template>
            <!-- </v-row> -->
          </vuescroll>
        </v-layout>

        <p
          v-if="!messageList.length && !loading"
          class="text-center text-body-2 grey--text mb-0"
        >
          No hay mensajes para mostrar
        </p>
      </v-card-text>
      <v-card-actions class="mx-2">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closeDialog()"
          >
            Cerrar
          </v-btn>
        </v-hover>

        <v-spacer></v-spacer>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'info' : 'grey'"
            @click="downloadCsv"
          >
            Descargar
          </v-btn>
        </v-hover>
      </v-card-actions>
    </v-card>

    <!-- DIALOGO VER FOTO -->
    <v-dialog
      width="500"
      v-if="isActivePhotoPreview"
      v-model="isActivePhotoPreview"
      transition="dialog-bottom-transition"
    >
      <!-- <template v-slot:activator="{ props }">
        <v-btn v-bind="props" text="Open Dialog"> </v-btn>
      </template>

      <template v-slot:default="{ isActivePhotoPreview }"> -->
      <v-card>
        <v-card-title>
          <v-toolbar dense flat color="transparent">
            <v-btn small icon @click="isActivePhotoPreview = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Vista previa</v-toolbar-title>
            <v-spacer></v-spacer>
            <a :href="urlPhotoPreview" download>
              <v-btn small icon>
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
            </a>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-img :src="urlPhotoPreview"></v-img>
        </v-card-text>
      </v-card>
      <!-- </template> -->
    </v-dialog>
  </v-dialog>
</template>

<script>
import moment from "moment";
import vuescroll from "vuescroll";

import { generateMessageList } from "./utils";
import { PbxHttpClient } from "@/services/httpclient";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";

export default {
  props: {
    open: {
      type: Boolean
    },
    ticket: {
      type: Object
    },
    id: {
      type: String
    }
  },
  components: { vuescroll },
  data() {
    return {
      loading: false,
      messageList: [],
      urlPhotoPreview: "",
      isActivePhotoPreview: false
    };
  },

  filters: {
    getHour12Format(date) {
      const hour = moment(date).format("LT");
      return hour;
    },

    typeDoc(item) {
      const indicePunto = item.lastIndexOf(".");

      // Si se encuentra un punto, extrae los caracteres desde ese punto hasta el final
      if (indicePunto !== -1) {
        return item.slice(indicePunto + 1);
      } else {
        // Si no se encuentra un punto, devuelve la cadena completa
        return item;
      }
    },

    getNameVCard(VCARD) {
      // Expresión regular para extraer lo que está después de FN:
      const regex = /FN:(.*?)\n/;
      const match = VCARD.match(regex);
      const result = match[1];

      return result;
    },

    getNumberVCard(VCARD) {
      // Expresión regular para extraer lo que está después de FN:
      const regex = /waid=(.*?):/;
      const match = VCARD.match(regex);
      const result = match[1];

      return result;
    }
  },

  computed: {
    DialogTitle() {
      return `Mensajes de ${this.ticket?.contacts?.phone1 || ""}`;
    }
  },

  watch: {
    ticket(val) {
      if (!val) this.messageList = [];
      else this.getMessageList(val.id);
    }
  },

  mounted() {
    this.getMessageList(this.ticket.id);
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },

    openInNewTab() {
      const route = this.$router.resolve({ name: 'CDR Whatsapp newTab', params: { id: this.ticket.id } });
      window.open(route.href, '_blank');
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    photoPreview(url) {
      this.urlPhotoPreview = url;
      this.isActivePhotoPreview = true;
    },

    closePhotoPreview(url) {
      this.urlPhotoPreview = "";
      this.isActivePhotoPreview = false;
    },

    async getMessageList(ticket_id) {
      this.loading = true;
      try {
        const { data } = await PbxHttpClient.post(
          `/whatsapps/chat/index_chat`,
          {
            ticket_id
          }
        );
        // this.messageList = generateMessageList(res.data);

        // TODO: HOLA
        const messages = data;
        const reversedKeys = Object.keys(messages).reverse();

        reversedKeys.forEach((key) => {
          this.messageList.push(messages[key]);
        });
      } catch (err) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
        console.log(err);
      }
      this.loading = false;
    },

    async downloadCsv() {
      this.isLoading = true;

      const payload = {
        type: "CDR WhatsApp",
        payload: { idticket: this.ticket.id }
      };

      try {
        await CdrDownloadToCsv(payload, "cdrWhatsapp");

        this.isLoading = false;
        // this.activeDateModal = false;
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    }
  }
};
</script>

<style scoped>
pre {
  white-space: pre-line;
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>
